export const messages = {
  en: {
    businessDatabusManage: {
      queryCondition: 'Query Conditions',
      inputBusinessType: 'Please enter business type',
      inputAdapter: 'Please enter adapter',
      query: 'Query',
      reset: 'Reset',
      add: 'Add',
      id: 'ID',
      name: 'Name',
      businessType: 'Business Type',
      adapter: 'Adapter',
      seq: 'Sequence',
      status: 'Status',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      inUse: 'In Use',
      disabled: 'Disabled',
      confirmOperation: 'Please confirm your operation',
      confirmDelete: 'Confirm to delete?',
      cancel: 'Cancel',
      confirm: 'Confirm',
      addSuccess: 'Added successfully',
      editSuccess: 'Modified successfully',
      deleteSuccess: 'Deleted successfully',
      nameRequired: 'Name is required',
      nameTooLong: 'Name is too long',
      businessTypeRequired: 'Business type is required',
      adapterRequired: 'Adapter is required',
      adapterTooLong: 'Adapter name is too long',
      seqRequired: 'Sequence is required',
      seqFormatError: 'Sequence format error',
      statusRequired: 'Status is required',
      selectStatus: 'Please select status',
      inputName: 'Please enter name',
      inputSeq: 'Please enter sequence'
    }
  },
  zh: {
    businessDatabusManage: {
      queryCondition: '查询条件',
      inputBusinessType: '请输入业务类型',
      inputAdapter: '请输入适配器',
      query: '查询',
      reset: '重置',
      add: '添加',
      id: 'ID',
      name: '名称',
      businessType: '业务类型',
      adapter: '适配器',
      seq: '顺序',
      status: '状态',
      operation: '操作',
      edit: '修改',
      delete: '删除',
      inUse: '在用',
      disabled: '停用',
      confirmOperation: '请确认您的操作',
      confirmDelete: '确定删除?',
      cancel: '取消',
      confirm: '确认',
      addSuccess: '添加成功',
      editSuccess: '修改成功',
      deleteSuccess: '删除成功',
      nameRequired: '名称不能为空',
      nameTooLong: '名称太长',
      businessTypeRequired: '业务类型不能为空',
      adapterRequired: '适配器不能为空',
      adapterTooLong: '适配器名称太长',
      seqRequired: '顺序不能为空',
      seqFormatError: '顺序格式错误',
      statusRequired: '状态不能为空',
      selectStatus: '请选择状态',
      inputName: '请输入名称',
      inputSeq: '请输入顺序'
    }
  }
}